import styled from 'styled-components';

export const StyledReferrer = styled.div`
  background: #2d2720;
  border-radius: ${props => props.theme.borderRadius};
  color: #fff;
  font-size: ${props => props.theme.fontSizes.extraSmall};
  text-align: center;
  padding: 15px 0;
  margin: 15px 0;
`
